let pendingCode: string | null = null;

/** Capture before telemetry starts, then remove the code from the current history entry. */
export function captureMobileLoginCode(): void {
  if (typeof window === 'undefined' || window.location.pathname !== '/mobile-login') {
    return;
  }

  // A hard navigation can bootstrap Angular with an unrelated account already
  // in hs_token. Remove it before services or guards can restore that identity.
  try {
    window.localStorage.removeItem('hs_token');
  } catch {
    // Storage may be unavailable; the component still clears TokenService.
  }

  const url = new URL(window.location.href);
  const codes = url.searchParams.getAll('code');
  if (codes.length === 0) {
    return;
  }
  pendingCode = codes.length === 1 ? codes[0] : '';
  url.searchParams.delete('code');
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}

export function takeMobileLoginCode(): string | null {
  captureMobileLoginCode();
  const code = pendingCode;
  pendingCode = null;
  return code;
}
